import React from 'react'

function Toaster(props) {
    const type = props.type === 'success' ? 'success' : props.type === 'danger' ? 'danger' : 'info';
    const icon = type === 'success' ? 'fa-circle-check' : type === 'danger' ? 'fa-circle-exclamation' : 'fa-circle-info';
    const show = props.visiblity === 'show';
    return (
        <div
            className={`mlux-toast ${type} ${show ? 'show' : ''}`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
        >
            <span className="ic"><i className={`fas ${icon}`}></i></span>
            <div className="tx">
                {props.title && <div className="tt">{props.title}</div>}
                <div className="tb">{props.text}</div>
            </div>
        </div>
    )
}

export default Toaster;
